export const SPACES = [
  { name: "Hospitals & clinics", icon: "Hospital", hook: "OT, ICU & ward safety" },
  { name: "Schools & universities", icon: "School", hook: "Safe campuses, trained staff" },
  { name: "Shopping malls", icon: "ShoppingBag", hook: "High-footfall ready" },
  { name: "Hotels & restaurants", icon: "Hotel", hook: "Kitchens to guest floors" },
  { name: "Offices & IT parks", icon: "Building2", hook: "Audit-ready workplaces" },
  { name: "Airports", icon: "Plane", hook: "Terminal-grade protection" },
  { name: "Metro & railway stations", icon: "TrainFront", hook: "Crowd-scale response" },
  { name: "Cinemas & multiplexes", icon: "Clapperboard", hook: "Every screen, every exit" },
  { name: "Factories & warehouses", icon: "Factory", hook: "Industrial-duty systems" },
  { name: "Residential societies", icon: "Building", hook: "High-rise & township safety" },
  { name: "Government buildings", icon: "Landmark", hook: "Tender-ready compliance" },
  { name: "Banks & ATMs", icon: "Banknote", hook: "Branch & vault safety" },
  { name: "Data centres", icon: "Server", hook: "Clean-agent protection" },
  { name: "Religious places", icon: "Church", hook: "Safe gatherings" },
  { name: "Stadiums & auditoriums", icon: "Trophy", hook: "Event-day readiness" },
  { name: "Retail & supermarkets", icon: "ShoppingCart", hook: "Stores & back rooms" },
  { name: "Petrol pumps", icon: "Fuel", hook: "Fuel-fire specialists" },
  { name: "Parking areas", icon: "SquareParking", hook: "Basements & EV bays" },
];

export const ONE_STOP = ["Supply", "Wall-mounting", "Alarm & detection wiring", "AMC"];

export const QUOTE_SERVICES = ["Supply", "AMC"];
export const QUOTE_SIZES = ["Under 5,000 sq ft", "5,000 – 25,000 sq ft", "25,000 – 1 lakh sq ft", "1 lakh+ sq ft", "Not sure"];
export const QUOTE_SITES = ["1 site", "2 – 5 sites", "6 – 20 sites", "20+ sites"];
